const sortOptions = {
	en: [{
		key: "sort",
		filters:[
			{
				slug: "default",
				title: "Default",
			},
			{
				slug: "price-low-high",
				title: "Price (low to high)",
			},
			{
				slug: "price-high-low",
				title: "Price (high to low)",
			},
			{
				slug: "az",
				title: "A-Z",
			},
			{
				slug: "za",
				title: "Z-A",
			}
		]
	}],
	fr: [{
		key: "sort",
		filters: [
			{
				slug: "default",
				title: "Défaut",
			},
			{
				slug: "price-low-high",
				title: "Prix (bas à élevé)",
			},
			{
				slug: "price-high-low",
				title: "Prix (élevé à bas)",
			},
			{
				slug: "az",
				title: "A-Z",
			},
			{
				slug: "za",
				title: "Z-A",
			}
		]
	}]
};

export default sortOptions;